
export { default as Icon } from "./components/icon-elements/Icon/Icon.js"